import { Briefcase, Building2, GraduationCap, Rocket, TrendingUp, Laptop, Users } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";

const ICONS = [Briefcase, Building2, GraduationCap, Rocket, TrendingUp, Laptop];

export function WhoFor() {
  const { lang } = useLanguage();
  const t = CONTENT[lang].whoFor;

  return (
    <section className="bg-cream py-20 sm:py-28" data-testid="who-for">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading eyebrow={t.eyebrow} title={t.title} sub={t.sub} />

        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-4 sm:grid-cols-3">
          {t.roles.map((role, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={role} delay={(i % 3) * 80}>
                <div className="flex h-full flex-col items-center gap-2 rounded-2xl border border-navy/8 bg-white/70 p-6 text-center transition-all duration-300 hover:border-gold/40 hover:bg-white">
                  <span className="mb-1 flex h-11 w-11 items-center justify-center rounded-full bg-gold/12 text-gold ring-1 ring-gold/25">
                    <Icon className="h-5 w-5" strokeWidth={1.8} />
                  </span>
                  <span className="text-sm font-semibold text-navy">{role}</span>
                  {t.roleDescs?.[i] && (
                    <span className="text-xs leading-snug text-navy/55">{t.roleDescs[i]}</span>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={150} className="mx-auto mt-8 max-w-2xl">
          <div className="flex items-center justify-center gap-3 rounded-2xl bg-navy px-6 py-5 text-center">
            <Users className="h-5 w-5 shrink-0 text-gold" />
            <p className="text-sm font-medium text-cream sm:text-base">
              {lang === "hi"
                ? "और हर वह व्यक्ति जो बेहतर दैनिक स्पष्टता चाहता है।"
                : lang === "hinglish"
                ? "Aur har wo insaan jo better daily clarity chahta hai."
                : "And anyone else seeking better daily clarity."}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
